<div *ngIf="errorService.hasErrors()" class="alert alert-danger">
  <p class="mb-0" *ngFor="let error of errorService.errors">{{ error | translate }}</p>
</div>
